// Asking the browser's password manager to remember (or update) a credential.
//
// ── Why this is needed at all ────────────────────────────────────────────────
//
// Browsers decide to offer "save password?" by watching a form submission and
// the navigation that follows it. This app submits over XHR and then navigates
// with the router, so the page never unloads — which is exactly the case those
// heuristics handle worst. The Credential Management API lets us say it
// outright instead of hoping the heuristic fires.
//
// Chrome and Edge implement it; Firefox and Safari do not, hence the capability
// check. There the heuristic is the only path, which is why the forms still
// carry proper autocomplete attributes and keep a username field in the same
// <form> as the password — see the change-password panel on the profile page.
//
// Always awaited before navigating away: a pending save prompt is dropped if
// the tab moves on too quickly.
export async function saveCredential({ email, password, name }) {
  if (!email || !password) return false;
  try {
    if (!window.PasswordCredential || !navigator.credentials?.store) return false;
    await navigator.credentials.store(
      new window.PasswordCredential({
        id: email,
        password,
        // Storing under the same id as an existing entry updates it, which is
        // what makes this work for a password CHANGE and not just a first save.
        ...(name ? { name } : {}),
      })
    );
    return true;
  } catch (err) {
    // Never block the actual task on this — a declined, blocked or unsupported
    // save is not a failure of signing in or changing a password.
    console.debug("Credential save unavailable:", err);
    return false;
  }
}
